export const OCR_SUPPORTED_COUNTRIES = ['IN', 'PK']
